var _animateTransform, _animateTransform2, _animate;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiren(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1046.76 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M583.21,307.08s.18-13.11,6.65-20.58A60.47,60.47,0,0,1,604,274.69s56.38-17.55,98.38-21.53l105.37-10s31.35,7.06,46.41,12.6,46.23,18,54.31,28.35,10.75,13.6,11.64,22.34,4.79,73.72,4.79,73.72,1,108.47-1.33,124.24-2.32,38.74-3.49,43.47-1.87,12.4-11.94,16.07-46.08,14.7-82.38,20.59S721.41,600,691.47,600.26s-79.18-4.44-91-7.39c-10.61-2.66-16.7-15.19-17.3-24.67S576.55,327.67,583.21,307.08Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.94,459.47s2.83-107,5.58-119c.6-2.66,1.69-8.19,4.6-9.36,6.17-2.48,49.44-15,93.1-20s85.62-8.69,92.23-6.61,5,7.84,6.15,12.07c1.23,4.66,5.5,97,4.36,121.8s-3.84,93.3-4.63,103.74c-.51,6.81.28,10.57-9.5,13.69-12.07,3.86-46.75,14.16-80.24,18.93-35.26,5-84.84,7.83-96.62,8-2.66,0-8,1.37-9-6.35C722.28,563.76,717.32,478.6,717.94,459.47Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.21,307.08s72.32,12.88,91.54,18.14,48.77,15.2,48.77,15.2",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,274.69s62.36,18.6,94,34.45,30.16,21.92,30.16,21.92",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.44,463.25a70.27,70.27,0,0,1-8.2-1.45",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.86,380.21v10.64l-5.65,1.91L919,424.2S913.9,442.27,901.15,453a120.75,120.75,0,0,1-25.89,16.45l-.41-6.9-11.51,1.34.21,7.37-45.07-8h0l-8.2-1.45-.09,0h0c-24.41-5.88-37.67-23.93-43.88-50-9.21-38.67,8.78-82.14,47.46-95.26A66.61,66.61,0,0,1,833.36,313a.48.48,0,0,1,.12,0h0l36,9h0l22.1,5.55s22.66,9.33,26.95,28.07l.63,26Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "833.36 312.97 833.39 312.94 833.49 312.97",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "819.86 316.51 831.12 314.77 874.58 324.31 874.58 332.47 880.22 332.19 880.89 354.54 858.07 358.06 858.06 335.2 863.22 334.42 863.51 326.36 819.86 316.51",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.55,471.22s-27.39,1.13-42.16-28.21l-1.46-26.36a2.05,2.05,0,0,0-2.38-1.91l-4.44.73-.75-17.09,6.48-.72.1-23.81s7.71-35.18,44.57-47.49",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.87,388.2s.69-21.56,8.09-28.61l41.34,7.79-1.36,6.47-.1,23.81-6.48.72Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.88,406.74l42.23,8.73,4.86-.8a1.67,1.67,0,0,1,1.94,1.55L821.39,443,779,433.42S772.26,424.84,770.88,406.74Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.63,521l-.09,0s0-.06,0-.08.57-40.14.1-55.07c-.1-3-1.64-4.75-4.64-4.28l-48.61,7.67-65,10.05a2.76,2.76,0,0,1-1.07-.16,1.57,1.57,0,0,1-.28-.1,3.1,3.1,0,0,1-1-.76,3.06,3.06,0,0,1-.73-2.49v-4l0-.2-.13-1.82a4.19,4.19,0,0,0-.1-.71l-.33-1.53a4.83,4.83,0,0,0-.22-.74l-.5-1.3a4.68,4.68,0,0,0-.38-.78l-.62-1a5.21,5.21,0,0,0-.56-.77l-.67-.75a4.58,4.58,0,0,0-.76-.7l-.68-.51a4.9,4.9,0,0,0-1-.56l-1.19-.53-1.05-.2-.77-.14-1.75.07h-.13l-1.38.37a4.84,4.84,0,0,0-1,.36l-.95.47a5.52,5.52,0,0,0-.77.48l-1,.76a5.41,5.41,0,0,0-.62.55l-1,1a4.92,4.92,0,0,0-.5.61l-.9,1.3a4.72,4.72,0,0,0-.37.61l-.76,1.53a4.66,4.66,0,0,0-.26.61l-.52,1.52-.17.48-.16.8,0,.19-.22,1.09c0,.22-.07.45-.09.67l-.13,1.93c0,.11,0,.22,0,.34v3.83h0a4.37,4.37,0,0,1-3.12,4.49L743.75,486c-1.94.55-3,2-3.12,4.49l0,55.74v.13a3,3,0,0,0,.74,2.5,2.2,2.2,0,0,0,.35.33,3,3,0,0,0,2,.69l65-10,.39-.06h.25a3.14,3.14,0,0,1,1.34.38,3.06,3.06,0,0,1,1.54,3.13v3.84c0,.11,0,.23,0,.35l.13,1.85a5.77,5.77,0,0,0,.1.71l.33,1.53a6.29,6.29,0,0,0,.22.74l.51,1.3a4.2,4.2,0,0,0,.37.77l.62,1a5.21,5.21,0,0,0,.56.77l.67.75a4.64,4.64,0,0,0,.77.7l.87.65.25.19,1.71.76.16,0,1.09.21a5,5,0,0,0,1.16.08l.75,0a4.86,4.86,0,0,0,1.07-.16l.85-.23a5.26,5.26,0,0,0,1-.36l.95-.47a5.52,5.52,0,0,0,.77-.48l1-.76a5.32,5.32,0,0,0,.61-.55l1-1a4.85,4.85,0,0,0,.49-.61l.9-1.3a4.72,4.72,0,0,0,.37-.61l.77-1.53a5.22,5.22,0,0,0,.25-.61l.58-1.68a4,4,0,0,0,.18-.66l.35-1.75a3.62,3.62,0,0,0,.09-.66l.13-2V540a4.35,4.35,0,0,1,3-4.41.07.07,0,0,1,.06,0l.11,0,65.19-10.08.19,0a4.39,4.39,0,0,0,3.13-4.41",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 841.26,
    cy: 403.22,
    rx: 12.15,
    ry: 15.24,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 900.05,
    cy: 394.23,
    rx: 12.15,
    ry: 15.24,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844,393.38a6.38,6.38,0,0,0-2.77-.62",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.08,412.47c0,5.21-3.85,9.43-8.6,9.43l-2.91-.55-42.29-8v-.08c-4-.61-7.13-4.94-7.13-10.2,0-5.68,3.62-10.28,8.1-10.28l2.77.62h0L887.36,403l0,.22A9.28,9.28,0,0,1,894.08,412.47Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.24,403.33c0,5.21-3.85,9.43-8.6,9.43l-2.91-.55-42.29-8v-.08c-4-.6-7.13-4.94-7.13-10.2,0-5.68,3.62-10.28,8.11-10.28l2.76.62h0l43.31,9.66,0,.22A9.28,9.28,0,0,1,953.24,403.33Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.48,421.9a7.88,7.88,0,0,1-2.91-.55",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724,576.34s-19.46,8-40.36,8S583.21,568.2,583.21,568.2",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.22,582.8S722,593.18,699.43,598c-31.35,6.65-98.92-5.1-98.92-5.1",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.94,459.47s-7.58.42-26.11-1.48-111.39-19.7-111.39-19.7",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.22,311s-2.29-9.5-15.38-18.82c-33-23.52-103.5-39-103.5-39",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.45,304.42s-.25-8.22-7.58-18.2-47.81-29-47.81-29",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779,359.59V386.7l-8.09,1.5,41.49,10.18,5.85-.65a2,2,0,0,0,1.79-2.1l-1.06-21.78,1.36-6.47Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 778.96,
    y1: 386.7,
    x2: 820.04,
    y2: 396.42,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.34,
    cy: 568.57,
    rx: 2.44,
    ry: 3.21,
    style: {
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "822.58 573.18 822.58 685.64 778.96 685.64",
    style: {
      fill: "none",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.3,573.74A11.28,11.28,0,1,1,822.58,585,11.28,11.28,0,0,1,811.3,573.74Z",
    style: {
      fill: "#f26850"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.85,708.67a87.19,87.19,0,0,1-1,13.41,83.21,83.21,0,0,1-1.84,8.69A85.39,85.39,0,0,1,747.3,781.4c-1.53,1-3.16,1.85-4.79,2.72-2.06,1.09-4.13,2.07-6.19,3-2.51,1.08-5.22,2.06-7.83,2.93-1.74.55-3.48,1.09-5.22,1.52a54.34,54.34,0,0,1-6.09,1.31,83.1,83.1,0,0,1-14.79,1.3c-1.3,0-2.61,0-3.91-.11-1.74-.1-3.37-.21-5.11-.43s-3.37-.44-5.11-.65c-1.41-.22-2.83-.55-4.13-.76a85.23,85.23,0,0,1-29.36-12.51c-1.41-1-2.82-1.95-4.13-3a86.52,86.52,0,0,1-26-32.35c-.14-.27-.25-.54-.37-.81s-.15-.32-.22-.47c-1.11-2.5-2.11-5.07-3-7.69-.63-1.88-1.15-3.75-1.68-5.73l-.06-.25a86.51,86.51,0,0,1-2.5-19.24v-1.52a32.18,32.18,0,0,1,.11-3.26c.07-1.87.2-3.73.4-5.58a85.55,85.55,0,0,1,19.06-45.52l.39-.48c.76-.93,1.6-1.86,2.44-2.79,1.58-1.74,3.25-3.42,5-5a85.91,85.91,0,0,1,14.57-10.92,84.07,84.07,0,0,1,20.39-8.77,85.49,85.49,0,0,1,23.34-3.22,80.55,80.55,0,0,1,17,1.74,29.1,29.1,0,0,1,4.13,1A83.69,83.69,0,0,1,739,631.37a85.4,85.4,0,0,1,48.87,77.3Z",
    style: {
      fill: "#fff",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.85,708.67a87.19,87.19,0,0,1-1,13.41,83.21,83.21,0,0,1-1.84,8.69,553.91,553.91,0,0,1-63.09,14.48c-23,3.74-58.88,9-89.63,12.32a85.23,85.23,0,0,1-7.6-13.19c-.14-.27-.25-.54-.37-.81s-.15-.32-.22-.47c-1.11-2.5-2.11-5.07-3-7.69-.63-1.88-1.15-3.75-1.68-5.73l-.06-.25a86.51,86.51,0,0,1-2.5-19.24v-1.52a32.18,32.18,0,0,1,.11-3.26c.07-1.87.2-3.73.4-5.58a85.55,85.55,0,0,1,19.06-45.52l.39-.48c.76-.93,1.6-1.86,2.44-2.79,1.58-1.74,3.25-3.42,5-5a85.91,85.91,0,0,1,14.57-10.92,84.07,84.07,0,0,1,20.39-8.77,85.49,85.49,0,0,1,23.34-3.22,80.55,80.55,0,0,1,17,1.74,29.1,29.1,0,0,1,4.13,1A83.69,83.69,0,0,1,739,631.37a85.4,85.4,0,0,1,48.87,77.3Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.85,708.67a87.19,87.19,0,0,1-1,13.41c-16.3,4.54-38.94,10.09-61,13.25-35.26,5-84.85,7.83-96.62,8-1.33,0-3.3.36-5.08-.26-1.11-2.5-2.11-5.07-3-7.69-.63-1.88-1.15-3.75-1.68-5.73-.58-7.08-1.32-17.79-2-29.85a85.55,85.55,0,0,1,19.06-45.52l.39-.48c.76-.93,1.6-1.86,2.44-2.79,1.58-1.74,3.25-3.42,5-5a85.91,85.91,0,0,1,14.57-10.92,84.07,84.07,0,0,1,20.39-8.77,85.49,85.49,0,0,1,23.34-3.22,80.55,80.55,0,0,1,17,1.74,29.1,29.1,0,0,1,4.13,1A83.69,83.69,0,0,1,739,631.37a85.4,85.4,0,0,1,48.87,77.3Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.36,688.09l-52.16,8.06a.28.28,0,0,0-.11.05.08.08,0,0,0-.07,0,4.35,4.35,0,0,0-2.95,4.41h0v4.09l-.13,2a4.91,4.91,0,0,1-.08.67l-.35,1.75a4.45,4.45,0,0,1-.19.65l-.57,1.68c-.08.21-.17.42-.26.61l-.76,1.54a6.62,6.62,0,0,1-.37.61l-.91,1.3a5.69,5.69,0,0,1-.49.61l-1,1a5.48,5.48,0,0,1-.61.56l-1,.76a8.36,8.36,0,0,1-.77.48l-.94.46a4.52,4.52,0,0,1-1,.37l-.85.22a4.48,4.48,0,0,1-1.08.16l-.75,0a4.91,4.91,0,0,1-1.15-.08l-1.1-.21-.15,0-1.72-.75-.25-.2-.87-.64a4.64,4.64,0,0,1-.77-.7l-.67-.75a5.52,5.52,0,0,1-.56-.78l-.62-1a6,6,0,0,1-.37-.77l-.51-1.3c-.08-.24-.16-.49-.22-.74l-.32-1.54a4.08,4.08,0,0,1-.11-.7l-.13-1.85c0-.12,0-.24,0-.36V704a3.09,3.09,0,0,0-.73-2.49,3.05,3.05,0,0,0-2.15-1h-.24l-.4.06-65,10a3.05,3.05,0,0,1-2-.7,1.81,1.81,0,0,1-.35-.33,3,3,0,0,1-.74-2.49v-.13l0-53.08c.76-.93,1.6-1.86,2.44-2.79,1.58-1.74,3.25-3.42,5-5l11.41-1.76a4.36,4.36,0,0,0,3.12-4.49v-3.84c0-.11,0-.22,0-.34l0-.49a84.07,84.07,0,0,1,20.39-8.77l.41,1.09a4.83,4.83,0,0,1,.22.74l.34,1.53a4.18,4.18,0,0,1,.09.71l.14,1.82v4.21a3.09,3.09,0,0,0,.74,2.49,2.85,2.85,0,0,0,1,.76,1.62,1.62,0,0,0,.28.11,3.29,3.29,0,0,0,1.08.16L739,631.37A85.56,85.56,0,0,1,785.36,688.09Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.38,743.48a9.15,9.15,0,0,1-.73.9c-.14-.27-.25-.54-.37-.81Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 717.5,
    cy: 729.25,
    rx: 2.44,
    ry: 3.21,
    style: {
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.85,708.67a87.19,87.19,0,0,1-1,13.41,83.21,83.21,0,0,1-1.84,8.69A85.39,85.39,0,0,1,747.3,781.4c-1.53,1-3.16,1.85-4.79,2.72-2.06,1.09-4.13,2.07-6.19,3-2.51,1.08-5.22,2.06-7.83,2.93-1.74.55-3.48,1.09-5.22,1.52a54.34,54.34,0,0,1-6.09,1.31,83.1,83.1,0,0,1-14.79,1.3c-1.3,0-2.61,0-3.91-.11-1.74-.1-3.37-.21-5.11-.43s-3.37-.44-5.11-.65c-1.41-.22-2.83-.55-4.13-.76a85.23,85.23,0,0,1-29.36-12.51c-1.41-1-2.82-1.95-4.13-3a86.52,86.52,0,0,1-26-32.35c-.14-.27-.25-.54-.37-.81s-.15-.32-.22-.47c-1.11-2.5-2.11-5.07-3-7.69-.63-1.88-1.15-3.75-1.68-5.73l-.06-.25a86.51,86.51,0,0,1-2.5-19.24v-1.52a32.18,32.18,0,0,1,.11-3.26c.07-1.87.2-3.73.4-5.58a85.55,85.55,0,0,1,19.06-45.52l.39-.48c.76-.93,1.6-1.86,2.44-2.79,1.58-1.74,3.25-3.42,5-5a85.91,85.91,0,0,1,14.57-10.92,84.07,84.07,0,0,1,20.39-8.77,85.49,85.49,0,0,1,23.34-3.22,80.55,80.55,0,0,1,17,1.74,29.1,29.1,0,0,1,4.13,1A83.69,83.69,0,0,1,739,631.37a85.4,85.4,0,0,1,48.87,77.3Z",
    style: {
      fill: "none",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 717.89,
    cy: 728.87,
    rx: 13.41,
    ry: 15.88,
    style: {
      fill: "none",
      stroke: "#f26850",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      strokeDasharray: 5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "776.63 724.36 754.62 724.36 754.62 712.98 726.45 729.25 754.62 745.51 754.62 734.14 776.63 734.14 776.63 724.36",
    style: {
      fill: "#f26850"
    }
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_siren_go_in",
    attributeName: "transform",
    type: "translate",
    from: "0 0",
    to: "-12 0",
    begin: "0.5s;hinava_random_uuid_siren_blink.end+1s",
    dur: "1.5s",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    id: "hinava_random_uuid_siren_go_out",
    attributeName: "transform",
    type: "translate",
    from: "-12 0",
    to: "0 0",
    begin: "hinava_random_uuid_siren_go_in.end+1s",
    dur: "1s",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M466.64,426.48c.84-41.61-2.47-89.77-7.83-141.17-1-15.15-11.54-28.56-25.47-28.56-44.83-4.59-93.55-6.24-144.83-8.28-51.28,2-100,3.69-144.83,8.28-13.93,0-24.5,13.41-25.47,28.56-5.36,51.4-8.67,99.56-7.82,141.17-.85,41.62,2.46,89.78,7.82,141.18,1,15.15,11.54,28.56,25.47,28.56,44.83,4.59,93.55,6.24,144.83,8.28,51.28-2,100-3.69,144.83-8.28,13.93,0,24.5-13.41,25.47-28.56C464.17,516.26,467.48,468.1,466.64,426.48Z",
    style: {
      fill: "#fff",
      stroke: "#0c0c0c",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.44,
    cy: 426.73,
    r: 94.48,
    transform: "matrix(0.86, -0.51, 0.51, 0.86, -176.76, 205.63)",
    style: {
      fill: "none",
      stroke: "#0c0c0c",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.08,426.73A109.64,109.64,0,1,0,288.44,536.36,109.63,109.63,0,0,0,398.08,426.73Z",
    style: {
      fill: "none",
      stroke: "#0c0c0c",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.5,
    y1: 588.44,
    x2: 288.5,
    y2: 572.76,
    style: {
      fill: "none",
      stroke: "#0c0c0c",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.19,438.16a1.68,1.68,0,0,1-.74-.71c-.12-.21-.13-.76-.15-5.58,0-3.59,0-5.49.06-5.75a1.39,1.39,0,0,1,2.25-.78c.52.45.52.48.55,2.78l0,2.07h9.27v-2.05c0-1.88,0-2.09.14-2.35a1.28,1.28,0,0,1,1.27-.77,1.31,1.31,0,0,1,1.32,1c.07.19.08,2,.07,5.79l0,5.52-.17.29a1.4,1.4,0,0,1-1.94.44c-.64-.41-.66-.52-.66-2.9v-2.05h-9.27l0,2.07c0,2,0,2.08-.2,2.36a1.36,1.36,0,0,1-1.14.71,1.8,1.8,0,0,1-.63-.06",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.49,438.13a1.53,1.53,0,0,1-.73-.79c-.05-.18-.07-2.19-.05-5.91l0-5.64.3-.31a1.34,1.34,0,0,1,1.25-.44.9.9,0,0,1,.75.38,2,2,0,0,1,.39.63c.12.41.12,10.75,0,11.16a1.67,1.67,0,0,1-.8.93,1.52,1.52,0,0,1-1.13,0",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.66,438.13a1.76,1.76,0,0,1-.7-.68c-.12-.21-.13-.74-.13-5.55a48.83,48.83,0,0,1,.1-5.61,2.57,2.57,0,0,1,.5-.7,2,2,0,0,1,1.72-.63c.69.05,1,.24,1.93,1.21.41.43,1.18,1.24,1.71,1.78l2.51,2.62,2.59,2.7,1,1.06,0-4.22c0-3.72.06-4.24.16-4.45a1.44,1.44,0,0,1,2.57.14c.06.15.09,2,.09,5.54,0,6,0,5.61-.56,6.21a2,2,0,0,1-1.43.68c-.77.06-1.24-.19-2.1-1.07l-4.23-4.42-2.84-2.95-.93-1v8.3l-.17.34a1.34,1.34,0,0,1-1.2.75,1.06,1.06,0,0,1-.65-.09",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,438.07a4,4,0,0,1,.61-7.8c.69-.1,8.35-.1,8.74,0a1.73,1.73,0,0,1,.93.79,1.29,1.29,0,0,1,.09.67,1.39,1.39,0,0,1-.73,1.15l-.28.17-4.34,0c-4.91,0-4.63,0-4.92.66a1.13,1.13,0,0,0,.13,1.21c.39.51.25.49,5.16.47l4.42,0,.46-.19a4,4,0,0,0,2.27-2.23,4.48,4.48,0,0,0,0-2.68,3.84,3.84,0,0,0-2.37-2.29c-.33-.12-.92-.14-5.54-.18-5.81,0-5.44,0-5.89-.62a1.06,1.06,0,0,1-.23-.84c0-.5,0-.53.31-.85a2.1,2.1,0,0,1,.51-.42c.16-.07,1.65-.08,5.58-.07l5.35,0,.71.25a6.68,6.68,0,0,1,2.9,1.9,6.18,6.18,0,0,1,.53.64,1.23,1.23,0,0,0,.18.31,6.31,6.31,0,0,1,.81,1.88,6.71,6.71,0,0,1,0,3.15,6.8,6.8,0,0,1-5,4.9c-.66.15-.9.16-5.28.16-4.56,0-4.59,0-5.13-.18",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,438.18a2.85,2.85,0,0,1-1.26-.8c-.29-.33-1.93-3.2-3.5-6.13l-.84-1.52c-1.39-2.48-1.62-2.94-1.62-3.29a1.43,1.43,0,0,1,1.28-1.41c.77-.06,1.2.26,1.8,1.39.89,1.67,4.74,8.65,4.81,8.73s.14-.09.23-.26.27-.52.4-.75l.51-.91c.67-1.24,2.08-3.8,2.72-4.94.38-.69.86-1.56,1.05-1.94.57-1.07.89-1.33,1.62-1.33a1.36,1.36,0,0,1,1.12.55,1,1,0,0,1,.24.84V427l-.75,1.33c-.64,1.15-2.24,4-3.11,5.65-.16.28-.35.62-.42.76s-.25.45-.39.7l-.38.68-.33.61a3.36,3.36,0,0,1-1.34,1.31,2.12,2.12,0,0,1-1,.22,3.38,3.38,0,0,1-.8,0",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,438.13a4.38,4.38,0,0,1-2.49-1.91,4,4,0,0,1,3-6c.39-.05,2.25-.07,4.72-.06l4.07,0,.3.23a2.23,2.23,0,0,1,.45.53,1.4,1.4,0,0,1-.92,2c-.21.06-1.68.09-4.42.09h-4.11l-.26.17a1.19,1.19,0,0,0,.08,2c.28.16.35.16,4.57.16,4.53,0,4.6,0,5.42-.36a3.82,3.82,0,0,0,1.92-2,2.93,2.93,0,0,0,.27-1.48,3.76,3.76,0,0,0-2-3.29c-.81-.44-.86-.44-6.2-.44-4.6,0-4.92,0-5.2-.14a1.39,1.39,0,0,1-.22-2.46l.22-.17h10.94l.61.21a6.74,6.74,0,0,1,2.2,1.2,6.63,6.63,0,0,1,1.75,2.12,5.68,5.68,0,0,1,.71,2.75,5.4,5.4,0,0,1-.13,1.72,7.66,7.66,0,0,1-.47,1.35,4.4,4.4,0,0,1-.87,1.37A6.76,6.76,0,0,1,330.5,438c-.51.16-.73.16-5.32.18a40.19,40.19,0,0,1-5.16-.09",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.44,
    cy: 426.73,
    r: 146.03,
    style: {
      fill: "none",
      stroke: "#0c0c0c",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.03,
    y1: 248.47,
    x2: 288.03,
    y2: 280.7,
    style: {
      fill: "none",
      stroke: "#0c0c0c",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.64,601.35c-24,1.22-48.74,2.14-74.13,3.14-25.45-1-50.25-1.92-74.26-3.14,2.54-4.37,5.23-9,7.08-12.25a5,5,0,0,1,.72-.93,4.48,4.48,0,0,1,3.28-1.25q15.79.76,31.56,1.14,7.89.18,15.77.29c5.25.06,10.5.09,15.72.09h.12q7.85,0,15.73-.09c5.24-.08,10.51-.17,15.77-.29q15.76-.37,31.56-1.14a3.88,3.88,0,0,1,1.18.11,4.32,4.32,0,0,1,1.13.43,4.43,4.43,0,0,1,1.69,1.64C357.51,592.51,360.18,597.11,362.64,601.35Z",
    style: {
      fill: "#777",
      stroke: "#0c0c0c",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 4
    }
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "hinava_random_uuid_siren_blink",
    attributeName: "fill",
    values: "#777777;#ffffff;#777777",
    begin: "hinava_random_uuid_siren_go_out.end",
    end: "hinava_random_uuid_siren_go_out.end+4.2s;",
    dur: "0.7s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiren);
export default __webpack_public_path__ + "static/media/siren.8b35def43a1430fab42e24ded9a17c18.svg";
export { ForwardRef as ReactComponent };